export class ChecklistController {
  constructor(props) {
    this.checklistModel = props.models.checklist
  }
  getChecklistConfig() {
    this.checklistModel.getConfig().then()
  }

  updateConfigProps(configData) {
    this.checklistModel.updateConfig(configData).then()
  }
}
